import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {WebDataRocksPivotComponent} from "./webdatarocks.angular4";
import {MaterialModule} from "../material.module";

@NgModule({
  declarations: [WebDataRocksPivotComponent],
  exports: [WebDataRocksPivotComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    MaterialModule
  ]
})
export class WebDataRocksModule {
}
